import React, { memo, useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import T from '@prisjakt/ui-translate';

import * as S from './styles';

type OwnProps = {
  id: number;
  name: string;
  logo: string | null;
  pathName: string;
  showPriceListExpandedPriceRowExperiment: boolean;
};

const RecommendedRetailer = memo(
  ({
    name,
    logo,
    pathName,
    id,
    showPriceListExpandedPriceRowExperiment,
  }: OwnProps) => {
    const { linkTo, t } = useContext(AppContext);

    return (
      <S.RecommendedRetailerExpansion to={linkTo('brand', { pathName, id })}>
        {showPriceListExpandedPriceRowExperiment && (
          <S.Wrapper>
            {t('store', 'store.recommended-retailer', { brand: name })}
            {logo ? <img src={logo} alt={name} /> : null}
          </S.Wrapper>
        )}
        {!showPriceListExpandedPriceRowExperiment && (
          <>
            {logo ? <img src={logo} alt={name} /> : null}
            <T domain="store">brand.recommended-retailer</T>
          </>
        )}
      </S.RecommendedRetailerExpansion>
    );
  }
);

export default RecommendedRetailer;
